import * as React from "react";

function SvgReview(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.268 5.5c.77-1.333 2.694-1.333 3.464 0L12.33 10c.77 1.333-.192 3-1.732 3H5.402c-1.54 0-2.502-1.667-1.732-3l2.598-4.5z"
        fill="#3C7A79"
      />
    </svg>
  );
}

export default SvgReview;
